import api from "../../api";
import {AxiosResponse} from "axios";
import {RoleModuleServiceInterface} from "../../types";
import {
    RoleAccessRequest,
    RoleEditRequest,
    RoleListRequest,
    RoleTranslationRequest,
    RoleViewRequest
} from "../../types/request";
import {RoleAccessResponse, RoleEditResponse, RoleListResponse, RoleViewResponse} from "../../types/response";
import {RolePrepareEditFormRequest} from "../../types/modules/role/request";
import {RolePrepareEditFormResponse} from "../../types/modules/role/response";

export class RoleService implements RoleModuleServiceInterface {
    public edit(request: RoleEditRequest): Promise<AxiosResponse<RoleEditResponse>> {
        return api.put(`/user_administration/role/${request.id}/edit`, request);
    }

    public list(request: RoleListRequest): Promise<AxiosResponse<RoleListResponse>> {
        return api.get('/user_administration/role/', { params: request });
    }

    public view(request: RoleViewRequest): Promise<AxiosResponse<RoleViewResponse>> {
        return api.get(`/user_administration/role/${request.id}/view`);
    }

    public accesses(request: RoleAccessRequest): Promise<AxiosResponse<RoleAccessResponse>> {
        return api.get(`/user_administration/role/${request.id}/view_role_accesses`);
    }

    public editAccesses(request: RoleAccessRequest): Promise<AxiosResponse<RoleAccessResponse>> {
        return api.put(`/user_administration/role/${request.id}/edit_role_accesses`, request);
    }

    public translations (request: RoleTranslationRequest) {
        return api.get(`/user_administration/role/${request.id}/translate`);
    }

    public editTranslations (request: RoleTranslationRequest) {
        return api.put(`/user_administration/role/${request.id}/translate`, request);
    }

    public prepareEditForm(request: RolePrepareEditFormRequest): Promise<AxiosResponse<RolePrepareEditFormResponse>> {
        return api.get(`/user_administration/role/${request.id}/prepare_edit`);
    }
}